var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#EBF4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0689 27.8333L14.9792 21.7436C14.8574 21.6218 14.8574 21.3782 14.9792 21.2564L17.7804 18.4551L16.4407 17.2372L13.6394 20.0385C12.7869 20.891 12.7869 22.2308 13.6394 23.0833L19.7292 29.1731H16.4407V31H22.8958V24.6667H21.0689V27.8333ZM30.2035 20.0385L24.1138 13.9487H27.4022V12H21.0689V18.3333H22.8958V15.1667L28.9856 21.2564C29.1074 21.3782 29.1074 21.6218 28.9856 21.7436L26.1843 24.5449L27.524 25.8846L30.3253 23.0833C31.0561 22.2308 31.0561 20.7692 30.2035 20.0385Z",
    fill: "#2E90FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/Update-icon.02b909b4ac1b511421e5a13a11eac167.svg";
export { ForwardRef as ReactComponent };